



































































import { Component, Vue, Inject } from "vue-property-decorator";
import LoginForm from "./login-form.vue";
import CreateAccount from "./create-account.vue";
import ForgetPassword from "./forget-password.vue";
// import EmailActivation from './email-activation.vue'
import LanguageSwitch from "@/components/language-switch.vue";
import BaseComponent from "@/asdcom/BaseComponent";
import { ButtonList } from "sweetalert/typings/modules/options/buttons";
import { AuthenticateModel } from "@/asdcom/apiproxy/apiproxy.dto";
import { Asdcom } from "@/asdcom/appservice.asdcom";

@Component({
  components: {
    LanguageSwitch,
    LoginForm,
    ForgetPassword,
    // EmailActivation,
    CreateAccount
  }
})
export default class Login extends BaseComponent {
  loading: boolean = false;
  showChangeTenant: boolean = false;
  loginModel: AuthenticateModel = new AuthenticateModel();

  async login() {
    this.ValidateAll().then(async (isValid: boolean) => {
      // abp.log.debug({ login: this.v_errors });
      if (isValid) {
        this.loading = true;
        //let tokenService = new Asdcom.TokenAuthAppService();
        //const loginRes = await tokenService.login(this.loginModel);
        const loginRes = await this.$appsvs.tokenAuth.loginStaff(this.loginModel);
        // abp.log.debug({ "login ret": loginRes });
        this.loading = false;

        if (loginRes.emailIsNotVerified) {
          const msgEl = document.createElement("div");
          msgEl.innerHTML = this.L(
            "UserEmailIsNotConfirmedAndCanNotLogin",
            undefined,
            this.L("ResendVerificationEmail")
          );
          // sweetAlert({
          //   title: this.L("EmailVerificationPending"),
          //   content: { element: msgEl },
          //   icon: "warning",
          //   buttons: {
          //     submit: {
          //       text: this.L("ResendVerificationEmail"),
          //       value: true,
          //       closeModal: false
          //     },
          //     cancel: this.L("Close")
          //   } as ButtonList
          // }).then((isResend: boolean) => {
          //   if (isResend) {
          //     msgEl.innerHTML = this.L("ReSendEmailVerificationLinkMessage");

          //     // this.$store
          //     //   .dispatch(
          //     //     "asdcom/account/sendEmailActivationLink",
          //     //     username
          //     //   )
          //      this.accountService.resendEmailActivationLink(loginRes.username)
          //       .then(() => {
          //         this.loginModel = new AuthenticateModel();
          //         this.$nextTick(() => {
          //           this.$validator.reset();
          //         });
          //         sweetAlert({
          //           title: this.L("Success"),
          //           content: { element: msgEl },
          //           icon: "success"
          //         });
          //       });
          //   }
          // });
        }

        //     }
        //   });

        // sessionStorage.setItem(
        //   "rememberMe",
        //   this.loginModel.rememberClient ? "1" : "0"
        // );
      }
      // else {
      //   // sweetAlert({ title: this.L("UnknownError"), icon: "error" });
      // }
    });
  }

  // get tenant() {
  //   return this.$store.state.session.tenant;
  // }

  // get currentForm() {
  //   if (this.$route.name === "login") {
  //     return "loginForm";
  //   }
  //   return this.$route.name;
  // }

  // created() {
  //   // Does nothing
  // }
}
